import { Filter, FilterOptionsProps } from '@utils/buckets/type'
import { MonitorEntity } from '@services/nomos_api/entities/monitor'
import { listMonitorsAPI } from '@services/nomos_api/resources/monitor/list'
import { fetchCasaOptions } from '@services/dados_abertos/resources/casa_options'
import { SCHEDULE_FILTER } from './types'
import { getAllSavedSearches } from '@services/nomos_api/resources/saved_searches/getAll'
import { getAllStakeholdersPagination } from '@services/nomos_api/resources/stakeholders/stakeholders'
import { searchEAgendasAPI } from '@services/nomos_api/resources/search/events'

const filterMonitors = async ({ text, page, limit }: FilterOptionsProps) => {
  const monitors = await listMonitorsAPI({ page, limit, q: text })
  return {
    pagination: monitors.pagination,
    results: monitors.results.map((monitor: MonitorEntity) => ({
      key: monitor.id,
      value: monitor.name,
    })),
  }
}

export default [
  {
    label: 'Agenda Executivo',
    key: SCHEDULE_FILTER.EAGENDA,
    attr: 'eagenda',
    enabled_input: true,
    enabled_pagination: false,
    enabled_online_filter: true,
    subFilter: [
      {
        label: 'Órgão',
        attr: 'eagenda_organ',
        enabled_input: true,
        enabled_pagination: true,
        enabled_online_filter: true,
        options: searchEAgendasAPI,
      },
      {
        label: 'Cargo',
        attr: 'eagenda_cargo',
        enabled_input: true,
        enabled_pagination: true,
        enabled_online_filter: true,
        options: searchEAgendasAPI,
        upperRef: 'eagenda_organ',
      },
      {
        label: 'Stakeholder',
        attr: 'eagenda_stakeholder',
        enabled_input: true,
        enabled_pagination: true,
        enabled_online_filter: true,
        options: searchEAgendasAPI,
        upperRef: 'eagenda_organ',
      },
    ],
  },
  {
    label: 'Casa Legislativa',
    key: SCHEDULE_FILTER.LEGISTATIVE,
    attr: 'openDataResource',
    enabled_input: true,
    enabled_pagination: false,
    enabled_online_filter: true,
    options: fetchCasaOptions,
  },
  {
    label: 'Painéis',
    attr: 'panel',
    enabled_input: true,
    enabled_pagination: true,
    enabled_online_filter: true,
    key: SCHEDULE_FILTER.PANELS,
    subFilter: [
      {
        label: 'Painel',
        attr: 'panel_monitors',
        enabled_input: true,
        enabled_pagination: true,
        enabled_online_filter: true,
        options: filterMonitors,
      },
      {
        label: 'Pesquisas Salvas',
        attr: 'panel_saved_searches',
        enabled_input: true,
        enabled_pagination: true,
        enabled_online_filter: true,
        options: getAllSavedSearches,
        upperRef: 'panel_monitors',
      },
      {
        label: 'Stakeholders Monitorados',
        attr: 'panel_stakeholders',
        enabled_input: true,
        enabled_pagination: true,
        enabled_online_filter: true,
        options: getAllStakeholdersPagination,
        upperRef: 'panel_monitors',
      },
      {
        label: 'Proposições Monitoradas',
        attr: 'panel_propositions',
        enabled_input: true,
        enabled_pagination: true,
        enabled_online_filter: true,
        upperRef: 'panel_monitors',
        type: 'switch',
      },
    ],
  },
] as Filter[]
